export const STORE_NEW_BLOCKED_USER = 'STORE_NEW_BLOCKED_USER';
export const STORE_DISMISSED_PROFILES = 'STORE_DISMISSED_PROFILES';
export const UPDATE_DISMISSED_PROFILES = 'UPDATE_DISMISSED_PROFILES';
export const UPDATE_BLOCKED_PROFILES = 'UPDATE_BLOCKED_PROFILES';
export const SET_IS_FETCHING_LIST = 'SET_IS_FETCHING_LIST';
export const SET_DELETED_LOADER = 'SET_DELETED_LOADER';

export interface Blocked {
  data: unknown[];
  meta: {
    pagination: {
      current_page: number;
      total_pages: number;
    };
  };
}

export interface BlockedState {
  howManyPagesLoaded: number;
  blockedItems: unknown[];
  dismissedProfiles: unknown[];
  dismissedPagination: null | {
    current_page: string;
    total_pages: string;
  };
  isFetchingProfileList: boolean;
  isDeletedLoader: boolean;
  pagination: null | {
    current_page: string;
    total_pages: string;
  };
}
interface STORE_NEW_BLOCKED_USER_ACTION {
  type: typeof STORE_NEW_BLOCKED_USER;
  payload: Blocked;
}
interface STORE_DISMISSED_PROFILES_ACTION {
  type: typeof STORE_DISMISSED_PROFILES;
  payload: Blocked;
}
interface UPDATE_DISMISSED_PROFILES_ACTION {
  type: typeof UPDATE_DISMISSED_PROFILES;
  payload: any;
}
interface UPDATE_BLOCKED_PROFILES_ACTION {
  type: typeof UPDATE_BLOCKED_PROFILES;
  payload: any;
}

interface SET_IS_FETCHING_LIST_ACTION {
  type: typeof SET_IS_FETCHING_LIST;
  payload: boolean;
}
interface SET_DELETED_LOADER_ACTION {
  type: typeof SET_DELETED_LOADER;
  payload: boolean;
}

export type BlockedActionType =
  | STORE_NEW_BLOCKED_USER_ACTION
  | STORE_DISMISSED_PROFILES_ACTION
  | UPDATE_DISMISSED_PROFILES_ACTION
  | UPDATE_BLOCKED_PROFILES_ACTION
  | SET_IS_FETCHING_LIST_ACTION
  | SET_DELETED_LOADER_ACTION;
